import { Link } from "react-router-dom";

const features = [
  {
    tag: "题材指南",
    title: "后宫番入坑指南：如何选对你的第一部后宫动漫漫画",
    desc: "后宫题材那么多，暧昧、同居、校园各不相同。新手入门该从哪部看起？这份入坑指南帮你理清后宫番的门派与看点，快速找到对胃口的那一部。",
    date: "本周专题",
    cover: "https://readdy.ai/api/search-image?query=anime%20collage%20style%20editorial%20image%20of%20a%20male%20protagonist%20surrounded%20by%20multiple%20cute%20anime%20girls%20with%20question%20marks%20and%20sparkles%2C%20soft%20warm%20coral%20and%20cream%20background%2C%20clean%20anime%20illustration%2C%20playful%20guide%20atmosphere%2C%20bright%20and%20friendly%20composition&width=1200&height=800&seq=feature-01&orientation=landscape",
  },
  {
    tag: "深度解读",
    title: "为什么我们爱看暧昧番：若即若离的心动美学",
    desc: "暧昧之所以迷人，在于一切都还未挑明。从校园日常到同居生活，那些藏在细节里的试探与心动，正是恋爱漫画最动人的地方。",
    date: "编辑手记",
    cover: "https://readdy.ai/api/search-image?query=artistic%20anime%20illustration%20of%20two%20people%20facing%20each%20other%20with%20soft%20glowing%20heart%20shapes%20floating%20between%20them%2C%20dreamy%20warm%20amber%20and%20rose%20tones%2C%20abstract%20romantic%20composition%2C%20clean%20anime%20style%2C%20poetic%20and%20gentle%20mood&width=1200&height=800&seq=feature-02&orientation=landscape",
  },
];

export default function FeatureSection() {
  return (
    <section id="feature" className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-sm font-medium text-primary-600 tracking-widest">EDITORIAL</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              恋爱题材专题解读
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((f) => (
            <article key={f.title} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70">
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={f.cover}
                  alt={`${f.title}专题配图`}
                  title={f.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {f.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs text-primary-600 font-medium">{f.date}</p>
                <h3 className="mt-2 font-heading font-semibold text-lg md:text-xl text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-sm text-primary-600 font-medium">
                  <span>阅读专题</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}